import { render, staticRenderFns } from "./ListProcesoElectoralGastoAdministracion.vue?vue&type=template&id=53fdc0da&scoped=true&"
import script from "./ListProcesoElectoralGastoAdministracion.vue?vue&type=script&lang=js&"
export * from "./ListProcesoElectoralGastoAdministracion.vue?vue&type=script&lang=js&"
import style0 from "./ListProcesoElectoralGastoAdministracion.vue?vue&type=style&index=0&id=53fdc0da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fdc0da",
  null
  
)

export default component.exports